module.exports = __webpack_public_path__ + "media/honey-icons/icon-door-back-91e9036e.svg";